<template>
  <div id="print-page">
    <div class="h-print mb-1">
      <b
        >Please ensure that the margin settings of your print to PDF is set to
        "None"</b
      >
    </div>
    <div class="print-page-wrapper">
      <div v-if="displayHeader" class="page-header">
        <div class="header-logo">
          <img src="/images/x-total.jpg" alt="logo" />
        </div>
        <div class="header-text">
          <img
            src="/images/total-expertise-arabic-header.png"
            alt="arabic header"
          />
          <h3>TOTAL Expertise For Trading &amp; Industrials Co. Ltd.</h3>
          <!-- <span v-if="displaySubheader" class="sub-header"
            >GCAA Approval No.: <b>UAE.145.0021</b></span
          > -->
        </div>
      </div>
      <div class="page-content">
        <table id="page-layout">
          <thead>
            <tr>
              <td>
                <div class="header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content"><slot></slot></div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="page-footer">
        <div class="footer-content text-center">
          <div class="custom-footer">
            <slot name="customFooter"></slot>
          </div>
          <!-- this is footer -->
          <!-- <slot name="extrafooter"></slot> -->
          <template v-if="displayExtraFooter">
            <div id="extrafooter" class="text-left">
              <a
                href="#"
                @click.prevent="viewEditDialog = true"
                title="Click here to edit footer"
              >
                <span class="mr-2">{{ footer.description }}</span>
                <span class="ui-icon el-icon-edit-outline"></span>
              </a>
            </div>
            <el-dialog
              title="Edit footer"
              :visible.sync="viewEditDialog"
              width="50%"
              :close-on-click-modal="false"
              @open="loadFooters"
              v-loading="isLoading"
            >
              <el-form ref="footerForm" :model="footerEdit" :rules="rules">
                <el-form-item label="Footer options" v-show="!viewEdit">
                  <el-select v-model="footer.id">
                    <el-option
                      v-for="item in footers"
                      :key="item.id"
                      :value="item.id"
                      :label="item.description"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="Footer Description"
                  v-show="viewEdit"
                  prop="description"
                >
                  <el-input
                    v-model="footerEdit.description"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="d-flex justify-content-flex-end">
                <el-button
                  size="small"
                  type="info"
                  v-show="!viewEdit"
                  v-if="false"
                  >New</el-button
                >
                <el-button
                  size="small"
                  @click="editFooter"
                  type="info"
                  v-show="!viewEdit"
                  >Edit Selected</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  v-show="viewEdit"
                  @click="updateFooter"
                  >Save</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  v-show="!viewEdit"
                  @click="useFooter"
                  >Use Selected</el-button
                >
                <el-button size="small" @click="viewEditDialog = false"
                  >Cancel</el-button
                >
              </div>
            </el-dialog>
          </template>
          <template v-if="displayFooter">
            <span class="footer-divider"></span>
            <div class="d-flex justify-content-space-around">
              <div>
                <span
                  >Mussafah Ind’l. Area, ICAD 3 – M/41, Warehouse B1501-P.O. Box
                  91219</span
                >
                <div class="d-flex justify-content-space-between">
                  <span>Tel.:+971 2 5509485,</span>
                  <span>Fax: +971 2 5509484,</span>
                  <span>Abu Dhabi, U.A.E.</span>
                </div>
              </div>
              <img src="/images/total-expertise-arabic-footer.png" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
export default {
  props: [
    "viewFooter",
    "viewSubheader",
    "viewHeader",
    "viewExtraFooter",
    "type"
  ],
  data() {
    return {
      footers: [],
      footer: {},
      footerEdit: {},
      viewEditDialog: false,
      viewEdit: false,
      rules: {
        description: [{ required: true }]
      },
      isLoading: false
    };
  },
  computed: {
    displayFooter() {
      if (this.viewFooter === false) return false;
      return true;
    },
    displayHeader() {
      if (this.viewHeader === false) return false;
      return true;
    },
    displaySubheader() {
      if (this.viewSubheader === false) return false;
      return true;
    },
    displayExtraFooter() {
      if (this.viewExtraFooter === true) return true;
      return false;
    }
  },
  mounted() {
    this.$store.dispatch("ui/togglePrintView");
    this.loadFooters();
  },
  methods: {
    loadFooters() {
      this.isLoading = true;
      api.get(`/api/v1/dashboard/get_footer/`).then(resp => {
        if (resp && resp.status == 200) {
          if (
            "data" in resp.data &&
            "msg" in resp.data.data &&
            resp.data.data.msg.length > 0
          ) {
            this.footers = resp.data.data.msg;
            // this.footers.push({ id: 99, description: "test" });
            this.footer = { ...this.footers[0] };
          }
        }
        this.isLoading = false;
      });
    },
    updateFooter() {
      this.$refs.footerForm.validate(valid => {
        if (!valid) return false;

        this.isLoading = true;
        api
          .put(
            `/api/v1/dashboard/update_footer/${this.footerEdit.id}/`,
            this.footerEdit
          )
          .then(resp => {
            if (resp && resp.status == 200) {
              let data = resp.data.data.msg;
              if (data.code == 200) {
                this.viewEdit = false;
                this.viewEditDialog = false;
                this.footer = { ...this.footerEdit };
              }
            }
            this.isLoading = false;
          });
      });
    },
    editFooter() {
      this.viewEdit = true;
      this.footerEdit = { ...this.footer };
    },
    useFooter() {
      let footer = this.footers.find(o => {
        return o.id == this.footer.id;
      });
      if (footer) {
        this.footer = { ...footer };
        this.viewEditDialog = false;
      }
    }
  }
};
</script>
<style lang="scss">
.footer-divider {
  display: block;
  border-bottom: 1px solid #333;
  border-top: 1px solid #333;
  padding: 2px;
  margin-bottom: 8px;
  margin-top: 8px;
}
.header-text .sub-header {
  width: 100%;
  text-align: center;
  display: block;
  font-size: 10px;
}
#print-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #dadce0;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 16px;
  font-family: "Calibri", sans-serif;
  .print-page-wrapper {
    width: 210mm;
    min-height: 296mm;
    padding: 8mm 14mm;
    background: #fff;
  }
  .page-header {
    display: flex;
    font-family: "Times-New-Roman", serif;
    justify-content: center;
    .header-logo {
      width: 60px;
      margin-right: 15px;
      img {
        width: 100%;
      }
    }
    .header-text {
      margin-top: -5px;
      h3 {
        font-size: 24px;
        margin-top: -10px;
        border-bottom: 2px solid #4343a1;
      }
    }
  }
  .footer-content {
    margin-top: 30px;
    font-size: 12px;
  }
  .page-content {
    #page-layout {
      width: 100%;
      // margin-top: calc(120px - 72px);
      > thead {
        display: none;
      }
      > tfoot {
        display: none;
      }
    }
  }
}

#extrafooter {
  color: #333;
  a {
    color: #333;
  }
}

.custom-footer {
  font-size: 14px;
}

@media screen {
  .print-page-wrapper {
    display: flex;
    flex-direction: column;
    .page-content {
      flex-grow: 1;
    }
  }
  .page-footer {
    // position: absolute;
    // bottom: 50px;
    // width: 687px;
  }
}

@media print {
  body,
  #app {
    height: 100%;
    .h-print {
      display: none;
    }
  }
  #print-page {
    padding-top: 0;
    padding-bottom: 0;
    .page-header {
      width: 100%;
      position: fixed;
      // top: 10px;
      left: 0;
      padding-top: 8mm;
      overflow: hidden;
    }
    .page-footer {
      width: 100%;
      position: fixed;
      // bottom: 10px;
      left: 0;
      overflow: hidden;
      bottom: 5mm;
      .footer-content {
        margin-top: 0;
      }
      .footer-divider {
        width: 90%;
        margin-left: 5%;
      }
    }
    .print-page-wrapper {
      padding-top: 0;
      padding-bottom: 0;
      width: 100% !important;
    }
    .header-space {
      height: 120px;
    }
    .footer-space {
      // background-color: red;
      height: 80px !important;
      width: 100%;
    }
    #page-layout {
      > thead {
        display: table-header-group !important;
      }
      > tfoot {
        display: table-footer-group !important;
      }
    }
  }
  #extrafooter {
    margin-left: 14mm;
    .ui-icon {
      display: none;
    }
  }
  .custom-footer {
    margin-left: 14mm;
  }
}

@page {
  size: A4;
  margin: 0;
}

table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
</style>
